// /**
//  * parcel - Add
//  */

// React
import React, {useContext, useEffect} from 'react';

// UI
import {makeStyles, Theme, createStyles} from '@material-ui/core/styles';
import {TextField, Grid, Button} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiCounter,
  mdiArchiveOutline,
  mdiFormatListBulletedType,
  mdiCashMultiple,
  mdiCalendar,
} from '@mdi/js';

// Type
import {AddInventoryItemCreateParcel} from '../parcels/interfaces';
import {Variant, VariantFeature} from '../products/interfaces';
import {Product} from '../products/interfaces';

// helpers'
import AuthContext from '../../authContext';
import List from './variantUnitList';
import {warehouseZoneUnits} from '../warehouseZone-unit/interfaces';
import {Item} from './interfaces';

type Props = {
  packItem: (serial: string) => void;
  onClose: () => void;
  serialNumber: boolean;
};

type Inputs = {
  amount: number;
  unitCost: string;
  productionDate: string;
  expirationDate: string;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    detail: {
      borderBottom: '1px solid #d8d8d8',
      margin: 0,
      paddingBottom: '10px',
      marginBottom: '20px',
      width: '100%',
      '& .icon, & h4.property': {
        color: '#8a8a8a',
      },
      '& .MuiDivider-root': {
        margin: '24px 0',
        color: '#d8d8d8',
      },
      '& h4': {
        margin: 0,
        padding: '0 8px',
      },
    },
    margin: {
      // margin: theme.spacing(1),
    },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },
    textField: {
      // width: '25ch',
    },
    textInput: {
      // width: '25ch',
      '& input, .MuiSelect-root': {
        padding: '6px 0 12px !important',
      },

      '& .MuiInput-underline::before': {
        borderBottom: '1px solid #d8d8d8 !important',
      },
    },
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontWeight: 500,
      width: '100%',
      '& > *': {
        // margin: theme.spacing(0, 0, 0, 1),
      },
    },
    icon: {
      // marginRight: theme.spacing(1),
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '8px',
      marginTop: '21px',
    },
    addIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      // marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.green.main,
      },
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  })
);

export default function Add(props: Props) {
  const classes = useStyles();
  const [serial, setSerial] = React.useState("");

  const pickItem = () => {
    props.packItem(serial);
  };

  useEffect(() => {
    setSerial("");
  }, [props.serialNumber])

  useEffect(() => {
    if (serial.length === 10) {
      props.packItem(serial);
      setSerial("");
    }
  }, [serial])

  return (
    <>
      <div style={{width: '500px'}}>
        <Grid
          className={classes.detail}
          container
          spacing={5}
          alignItems="center"
        >
          {'سریال کالای مورد نظر را اسکن کنید'}
        </Grid>

        <Grid>
          <TextField
            fullWidth
            id="serialNumber"
            name="name"
            autoFocus
            value={serial}
            onChange={e => setSerial(e.target.value)}
            label="شماره سریال"
          />
        </Grid>
        <Grid container spacing={2} style={{ marginTop: '30px' }}>
          <Grid item container xs={8}>
            <Button
              fullWidth
              type="button"
              size="large"
              data-cy="search"
              autoFocus
              variant="contained"
              color="secondary"
              onClick={pickItem}
              disabled={!serial}
            >
              {'تایید بسته بندی'}
            </Button>
          </Grid>
          <Grid item container xs={4}>
            <Button
              fullWidth
              variant="contained"
              onClick={props.onClose}
              size="large"
              data-cy="search"
            >
              {'انصراف'}
            </Button>
          </Grid>
        </Grid>
      </div>
    </>
  );
}
